import axios from "axios";
import { useEffect, useState } from "react";
import Card from "../Card";
import ResutsByTitle from "./ResutsByTitle";
const key = "b55d580200c51623fe9608f8f064a09b";

const SearchForm = () => {
  const [titleToSearchState, setTitleToSearchState] = useState(false);
  const [inputContent, setInputContent] = useState("");
  const [showMoviesByTitle, setShowMoviesByTitle] = useState("");
  const [pageToShow, setPageToShow] = useState("");

  useEffect(() => {
    getMoviesByTitle();
  }, [pageToShow]);

  const getMoviesByTitle = async () => {
    const response = await axios.get(
      `https://api.themoviedb.org/3/search/movie?api_key=${key}&query=${titleToSearchState}&language=en-US&page=${pageToShow}`
    );
    setShowMoviesByTitle(response.data.results);
  };

  const queryTitle = [];
  // handler:
  const handlerSearch = (event) => {
    for (let i = 0; i < event.target.value.length; i++) {
      const element = event.target.value[i];
      if (element === " ") {
        // event.target.value[i] = "+";
        queryTitle.push("+");
      } else {
        queryTitle.push(element);
      }
    }
    setTitleToSearchState(queryTitle.join(""));
    setInputContent(event.target.value);
    getMoviesByTitle();
  };

  return (
    <div className="pt-4 " style={{ minHeight: "90vh" }}>
      <h2 className="genreTitle text-start pt-5 ms-3">Search some movies!</h2>
      <div className="input-group mb-3 form-container input-group pt-2 px-3">
        <span className="input-group-text" id="inputGroup-sizing-default">
          <i className="fa-solid fa-magnifying-glass fa-lg"></i>
        </span>
        <input
          id="titleToSearch"
          placeholder="Write some title.."
          value={inputContent}
          onChange={(event) => {
            setPageToShow(1);
            handlerSearch(event);
          }}
          type="text"
          className="form-control"
          aria-label="Sizing example input"
          aria-describedby="inputGroup-sizing-default"
        />
      </div>
      <div className="form-container input-group pt-4"></div>
      <h3
        className=" text-start ms-3 mb-1 "
        style={{ color: "rgb(187, 187, 187)" }}
      >
        Results
      </h3>
      <hr className="text-muted mx-3" />

      {inputContent !== "" && (
        <div className="paginationDiv">
          <div className="pagination p-2">
            {/*  */}
            <div
              className="prevPage"
              onClick={() => {
                // window.scrollTo(0, 0);
                setPageToShow((prevState) => {
                  if (prevState === 1) {
                    return 1;
                  }
                  return prevState - 1;
                });
              }}
            >
              <i className="fa-solid fa-play my-1"></i>
            </div>

            <div
              className="nextPage"
              onClick={() => {
                // window.scrollTo(0, 0);
                setPageToShow((prevState) => {
                  if (showMoviesByTitle.length === 0) {
                    return prevState;
                  }
                  return prevState + 1;
                });
              }}
            >
              <i className="fa-solid fa-play my-1"></i>
            </div>
            {/*  */}
          </div>
        </div>
      )}

      <ResutsByTitle
        showMoviesByTitle={showMoviesByTitle}
        inputContent={inputContent}
      />

      {inputContent !== "" && (
        <div className="paginationDiv">
          <div className="pagination p-2">
            {/*  */}
            <div
              className="prevPage"
              onClick={() => {
                window.scrollTo(0, 0);
                setPageToShow((prevState) => {
                  if (prevState === 1) {
                    return 1;
                  }
                  return prevState - 1;
                });
              }}
            >
              <i className="fa-solid fa-play my-1"></i>
            </div>

            <div
              className="nextPage"
              onClick={() => {
                window.scrollTo(0, 0);
                setPageToShow((prevState) => {
                  if (showMoviesByTitle.length === 0) {
                    return prevState;
                  }
                  return prevState + 1;
                });
              }}
            >
              <i className="fa-solid fa-play my-1"></i>
            </div>
            {/*  */}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchForm;
